import getValue from "../get-value/text";

export default function(value) {
  const unwrapped = getValue(value);
  return typeof unwrapped === "string"
    ? !Boolean(unwrapped.trim().length)
    : true;
}
